
  import { Vue, Component, Prop } from "vue-property-decorator";

  import PricePlanProvider from "@/components/payment/prices/PricePlanProvider.vue";
  import PriceCardView from "@/components/payment/prices/PriceCardView.vue";

  import { SubscriptionPlan } from "@/entities/payment/SubscriptionPlan";
  import { SubscriptionPlanInnerName, SubscriptionPlansInnerNames } from "@/entities/payment/InnerNames";
  import { Subscription, Subscription_Plan } from "@/generated/graphql";

  @Component({
    components: {
      PricePlanProvider,
      PriceCardView,
    },
  })
  export default class PricePlans extends Vue {
    @Prop({ type: Array, required: true }) readonly subscriptionPlans!: Subscription_Plan[];
    @Prop({ type: Object, default: undefined }) readonly currentSubscription?: Subscription;
    @Prop({ type: Number, default: 0 }) readonly activeManagersCount!: number;
  @Prop({ type: Array, required: true }) readonly generalSubscriptionPlans!: string[];

    subscriptionPlansInnerNames = SubscriptionPlansInnerNames;

    chosenPlan: SubscriptionPlanInnerName | null = null;

    get currentSubscriptionId(): string | undefined {
      return this.currentSubscription?.subscription_plan_id;
    }

    get subscriptionPlansDetails(): Record<SubscriptionPlanInnerName, SubscriptionPlan> {
      const plansDetails = this.subscriptionPlans
        .sort((planA, planB) => Number(planA.price) - Number(planB.price))
        .map((plan) => [plan.inner_name, plan]);

      return Object.fromEntries(plansDetails);
    }

    get generalSubscriptionPlansKeys(): string[] {
      const { ENTERPRISE, ...generalPlans } = this.subscriptionPlansDetails;
      return Object.keys(generalPlans);
    }

    choosePlan(innerName: SubscriptionPlanInnerName): void {
      this.chosenPlan = innerName;
    }

    getManagersCount(plan: Subscription_Plan): number {
      const accessPermissions = plan.subscription_plan_access_permission;

      if (!accessPermissions) {
        return 0;
      }

      return accessPermissions.managers_count;
    }
    isPremiumPlanAndCurrentPlan(innerSubscriptionName: string): boolean {
    return innerSubscriptionName === 'PREMIUM';
  }
  }
